export const selectUserAssetIds = state => state.entities.users.domains.assets.ids;
